export default __webpack_public_path__ + "static/slide-03-313d1c249214e3095ff55d92c673d331.png";